import { useEffect, useState } from "react"
import { fetchCSVTeamData } from "./Utils"
import UploadCSV from "../../../../teams/csv/UploadCSV"
import Button from "../../../../common/button/Button"
import { useLocation } from "react-router-dom"

const RenderImportCSV = ({ teamId, teamType }) => {

  const location = useLocation()
  const requestCSV = fetchCSVTeamData(teamId, teamType)
  const [ csvTeamData, setCSVTeamData ] = useState('')

  const csvButtonName = ( 
    requestCSV?.isLoading 
    || requestCSV?.isPending 
    || requestCSV?.isFetching )
    ? 'Loading...' 
    : requestCSV?.isError 
      ? requestCSV?.error 
      : 'Import CSV'

  useEffect(() => {
    if( requestCSV.data ){
      // set members new location to reload the current page
      requestCSV.data.teamAreaURL.members = location.pathname
      setCSVTeamData( requestCSV.data )
    }
  }, [requestCSV])

  return (
    <>
      {
        csvTeamData
        ? <UploadCSV
            modalClassNames='msync-modal-custom-csv'
            classNames='msync-button msync-button--is-style-outline'
            buttonTitle='Import CSV'
            data-team={ JSON.stringify( csvTeamData ) }
          />
        : <Button
            className='msync-button--is-style-outline'
            name={ csvButtonName }
            disabled='true'
          />
      }
    </>
  )
}

export default RenderImportCSV
